<template>
  <div class="stripe-bind-div">
    <div id="payment-element"></div>
    <div id="message"></div>
  </div>
</template>

<script>
import { API } from '@/net/http';
let Stripe = null;
import jsLoader from '../../utils/jsLoader';
export default {
  name: 'StripeBindCardPay',
  props: {
    billType: { type: String, default: 'test' },
    billId: { type: String, default: '' },
    orderNum: { type: String, default: '' },
  },
  data() {
    return {
      loading: true,
      // orderNum: this.$route.params.orderNumber,
      paymentMethod: '',
    };
  },
  mounted() {
    this.initJs();
    this._stripe = null;
    this._card = null;
    this._elements = null;
  },
  methods: {
    initJs() {
      this.loading = true;
      this.$emit('change-loading', true);
      jsLoader('https://js.stripe.com/v3/', 'stripe')
        .then(async () => {
          Stripe = window.Stripe;
          await this.initClientSecret();
        })
        .catch(() => {
          this.$Message.error({
            content: 'load stripe error',
            duration: 10,
          });
        })
        .finally(() => {
          this.$emit('change-loading', false);
          this.loading = false;
        });
    },
    initClientSecret() {
      this.loading = true;
      this.$emit('change-loading', true);
      let api = API.createTestPaymentIntent;
      let body = {};
      if (this.billType === 'prepayment') {
        api = API.createPrepaymentIntent;
        body = this.orderNum;
      }
      this.$post(api, body)
        .then(res => {
          if (res.success) {
            let { publicKey, clientSecret } = res.data;
            this._client_secret = clientSecret;
            this.bindDom(publicKey);
          } else {
            this.loading = false;
            this.$emit('change-loading', false);
            this.$Message.error({
              content: res.message,
              duration: 3,
            });
          }
        })
        .catch(() => {
          this.$emit('change-loading', false);
          this.loading = false;
        });
    },
    bindDom(publicKey) {
      const stripe = Stripe(publicKey);
      const options = {
        // mode: 'setup',
        // currency: 'usd',
        clientSecret: this._client_secret,
      };
      const elements = stripe.elements(options);
      this._elements = elements;

      // Create Element instances
      const paymentElement = elements.create('payment', {
        defaultValues: {
          billingDetails: {
            email: this.$store.state.app.userInfo.email,
          },
        },
      });

      // Mount the Elements to their corresponding DOM node
      paymentElement.mount('#payment-element');

      paymentElement.on('ready', event => {
        // Handle ready event
        this.$emit('dom-finished');
      });

      this._stripe = stripe;
      this.loading = false;
      this.$emit('change-loading', false);
    },
    async confirmPayment(isDefault) {
      if (this.loading) {
        return;
      }
      if (this._stripe) {
        try {
          this.loading = true;
          this.$emit('change-loading', true);
          const elements = this._elements;
          await elements.submit();

          const clientSecret = this._client_secret;
          const confirmPayment = await this._stripe.confirmPayment({
            elements,
            clientSecret,
            redirect: 'if_required',
            confirmParams: {
              // Return URL where the customer should be redirected after the SetupIntent is confirmed.
              return_url: window.location.origin + '/#/user/profile',
            },
          });
          // console.log('confirmPayment', confirmPayment);
          if (confirmPayment.error) {
            this.$Message.error({
              content: confirmPayment.error.message,
              duration: 3,
            });
            throw new Error(confirmPayment.error.message);
          }

          //成功后向服务器保存payment_method
          this.payment_method = confirmPayment.paymentIntent.payment_method;
          let api = API.savePaymentMethod;
          const body = {
            paymentMethod: this.payment_method,
            isDefault: isDefault,
          };
          if (this.orderNum) body.orderNum = this.orderNum;

          if (this.billType === 'prepayment') {
            api = API.prepaymentSuccess;
            body.paymentIntentId = confirmPayment.paymentIntent.id;
          }
          await this.$post(api, body).then(res => {
            if (!res.success) return;
            this.$emit('bind-success');
          });
        } finally {
          this.loading = false;
          this.$emit('change-loading', false);
        }
      }
    },
  },
};
</script>

<style lang="less" scoped>
.stripe-bind-div {
  margin-top: 20px;
}
</style>
